import React from "react";
import { connect } from "react-redux";
import { Flex, SelectInput, SVGButton, TextInput } from "/app/src/component";
import CompanyModel from "/app/src/model/Company/model";

const ButtonStyle = {
  marginTop: "2px",
  border: "2px solid lightgrey",
  borderRadius: "5px",
  marginLeft: "8px",
  padding: "4px",
};
class EmployeeDetails extends React.Component {
  constructor(props) {
    super(props);
    let emp = this.props.employee;
    this.state = {
      imageUrl: emp.image_url,
      name: emp.name,
      display_name: emp.display_name,
      id: emp.id,
      role: emp.role,
      verified: emp.verified,
      email: emp.email,
      expo_token: emp.expo_token,
      additionalEmail: "fredrik.broberg@jibber.se",
    };
    this.updateEmployee = this.updateEmployee.bind(this);
    this.deleteEmployee = this.deleteEmployee.bind(this);
    this.resetPassword = this.resetPassword.bind(this);
    this.verifyEmail = this.verifyEmail.bind(this);
  }

  updateEmployee() {
    this.props.dispatch(
      CompanyModel.updateEmployee(this.state.id, this.props.companyId, {
        name: this.state.name,
        display_name: this.state.display_name,
        role: this.state.role,
      })
    );
  }
  deleteEmployee() {
    this.props.dispatch(
      CompanyModel.deleteEmployee(this.state.id, this.props.companyId)
    );
  }
  resetPassword() {
    this.props.dispatch(
      CompanyModel.resetPassword(
        this.state.id,
        this.state.additionalEmail,
        this.props.companyId
      )
    );
  }
  verifyEmail() {
    this.props.dispatch(
      CompanyModel.verifyEmail(
        this.state.id,
        this.state.additionalEmail,
        this.props.companyId
      )
    );
  }
  render() {
    return (
      <Flex
        borderTop="3px solid black"
        wrap
        w="100%"
        padding="8px"
        my="10px"
        column
      >
        <Flex column>
          <Flex shrink={0} column>
            <Flex>
              <img src={this.state.imageUrl} width="50" height="50" alt="" />
              <Flex column marginLeft="8px">
                <Flex>{this.state.id}</Flex>
                <a href={`mailto:${this.state.email}`} target="_top">
                  {this.state.email}
                </a>
                <Flex wrap>
                  <Flex> {this.state.expo_token}</Flex>
                </Flex>
              </Flex>
            </Flex>
          </Flex>
        </Flex>

        <Flex w="100%" wrap>
          <Flex padding="5px" shrink={0} column>
            <Flex fontWeight="bold"> name </Flex>
            <TextInput
              name="name"
              value={this.state.name}
              onChange={(event) => {
                this.setState({ name: event.target.value });
              }}
            />
          </Flex>

          <Flex padding="5px" shrink={0} column>
            <Flex fontWeight="bold"> display </Flex>
            <TextInput
              name="display_name"
              value={this.state.display_name}
              onChange={(event) => {
                this.setState({ display_name: event.target.value });
              }}
            />
          </Flex>
          <Flex padding="5px" shrink={0} column>
            <Flex fontWeight="bold"> role</Flex>
            <SelectInput
              select={this.state.role}
              values={{
                admin: "admin",
                manager: "manager",
                employee: "employee",
              }}
              name="role"
              onChange={(e) => {
                this.setState({ role: e.target.value });
              }}
            />
          </Flex>
        </Flex>

        <Flex wrap>
          <SVGButton
            {...ButtonStyle}
            text="Save"
            title="change the user"
            onClick={this.updateEmployee}
            confirmationContent={
              <Flex column>
                <Flex borderBottom="1px solid grey">
                  Vill du spara denna användare
                </Flex>
                <Flex py="5px"> name: {this.state.name}</Flex>
                <Flex py="5px"> display_name: {this.state.display_name}</Flex>
                <Flex py="5px"> role: {this.state.role}</Flex>
                <Flex py="5px"> email: {this.state.email}</Flex>
                <Flex py="5px"> verified: {String(this.state.verified)}</Flex>
              </Flex>
            }
          />

          <SVGButton
            {...ButtonStyle}
            text="Delete"
            onClick={this.deleteEmployee}
            confirmationContent={
              <Flex column>
                <Flex borderBottom="1px solid grey">
                  Vill du tar bort denna användare
                </Flex>
                <Flex py="5px"> name: {this.state.name}</Flex>
                <Flex py="5px"> email: {this.state.email}</Flex>
                <Flex py="5px"> role: {this.state.role}</Flex>
              </Flex>
            }
          />
          <SVGButton
            {...ButtonStyle}
            disabled={!this.props.employee.verified}
            text="Reset Password"
            onClick={this.resetPassword}
            confirmationContent={
              <Flex column>
                <Flex>
                  <b>Reset user password</b>
                </Flex>

                <Flex mt="10px">Send additional email to </Flex>
                <TextInput
                  name="Addition address"
                  value={this.state.additionalEmail}
                  onChange={(event) => {
                    this.setState({ additionalEmail: event.target.value });
                  }}
                />
                <Flex py="5px">{this.state.name}</Flex>
                <Flex py="5px">{this.state.email}</Flex>
              </Flex>
            }
          />
          <SVGButton
            {...ButtonStyle}
            disabled={this.props.employee.verified}
            text="Veriferar email"
            onClick={this.verifyEmail}
            confirmationContent={
              <Flex column>
                <Flex>
                  <b>Verify Email</b>
                </Flex>

                <Flex mt="10px">Send additional email to </Flex>
                <TextInput
                  name="Addition address"
                  value={this.state.additionalEmail}
                  onChange={(event) => {
                    this.setState({ additionalEmail: event.target.value });
                  }}
                />
                <Flex py="5px">{this.state.name}</Flex>
                <Flex py="5px">{this.state.email}</Flex>
              </Flex>
            }
          />
        </Flex>
      </Flex>
    );
  }
}

export default connect((state) => {
  return {};
})(EmployeeDetails);



// WEBPACK FOOTER //
// src/layout/Dashboard/MainPanel/Overview/EmployeeDetails.js